import React, { useEffect, useState } from 'react';
import MatrixSidebarConnections from 'components/MatrixSidebarConnections';
import ButtonNew from 'components/inputs/ButtonNew';
import icons from 'img/icons';
import './ConnectionsSidebar.scss';
import Tooltip from 'components/Tooltip';
import { usePlayModeState } from 'state/PlayModeState';
import classNames from 'classnames';

const ConnectionsSidebar = ({
  matrix,
  chartView,
  setChartView,
  setConnectionsTabOpen,
}) => {
  // See TODO before removing
  const [descriptionOpen, setDescriptionOpen] = useState(false);

  // Show all connections checkbox on connections sidebar
  const [showAllConnections, setShowAllConnections] = useState(false);

  const nodeResults = usePlayModeState(state => state.nodeResults);

  return (
    <div className="MatrixSidebar MatrixSidebar-Connections interactiveTourGettingStarted-7">
      <div className="MatrixSidebar-Connections-header">
        <div className="MatrixSidebar-Connections-header-label">
          RESULTS
          <Tooltip left={true}>
            Hover over a node in the connections list to see the strength of the
            positive and negative relationships between it and other nodes
          </Tooltip>
        </div>
      </div>
      <div className="MatrixSidebar-scrollContainer">
        <div className="MatrixSidebar-section">
          {descriptionOpen ? (
            <>
              {showAllConnections ? null : (
                <div className="MatrixSidebar-sectionDescription">
                  <strong>Hover</strong> over a node to see which other nodes it
                  influences and is influenced by, as well as the connection
                  strength of those node relationships.
                </div>
              )}
              <svg width="100%" viewBox="0 -20 250 70">
                <image
                  x={0}
                  y={-15}
                  height={14}
                  href={icons.connectionSquare}
                />
                <text x={20} y={-7} dominantBaseline="middle" fontSize={12}>
                  Total connections for each node
                </text>
                <rect
                  x={(250 - 60) / 2}
                  y={(50 - 24) / 2}
                  height={24}
                  width={60}
                  fill="white"
                  rx={4}
                  ry={4}
                />
                <text
                  x={250 / 2}
                  y={50 / 2 + 3}
                  dominantBaseline="middle"
                  textAnchor="middle"
                  fontSize={14}
                >
                  Node
                </text>

                {/* Arrows */}
                <g
                  stroke={showAllConnections ? '#eb346c' : '#303752'}
                  strokeWidth={1.5}
                >
                  <line
                    x1={0}
                    x2={(250 - 60) / 2 - 5}
                    y1={50 / 2}
                    y2={50 / 2}
                  />
                  <line
                    x1={(250 - 60) / 2 - 9}
                    x2={(250 - 60) / 2 - 5}
                    y1={50 / 2 - 4}
                    y2={50 / 2}
                  />
                  <line
                    x1={(250 - 60) / 2 - 9}
                    x2={(250 - 60) / 2 - 5}
                    y1={50 / 2 + 4}
                    y2={50 / 2}
                  />
                </g>

                <g
                  stroke={showAllConnections ? '#00c3ff' : '#303752'}
                  strokeWidth={1.5}
                >
                  <line
                    x1={250}
                    x2={(250 + 60) / 2 + 5}
                    y1={50 / 2}
                    y2={50 / 2}
                  />
                  <line x1={250 - 4} x2={250} y1={50 / 2 - 4} y2={50 / 2} />
                  <line x1={250 - 4} x2={250} y1={50 / 2 + 4} y2={50 / 2} />
                </g>

                <text
                  x={((250 - 60) / 2 - 5) / 2}
                  y={50 / 2 - 5}
                  textAnchor="middle"
                  fontSize={11}
                >
                  {showAllConnections ? 'negative influence' : 'influenced by'}
                </text>
                <text
                  x={((250 + 60) / 2 + 5 + 250) / 2}
                  y={50 / 2 - 5}
                  textAnchor="middle"
                  fontSize={11}
                >
                  {showAllConnections ? 'positive influence' : 'influences'}
                </text>
              </svg>
            </>
          ) : null}
        </div>
        <div className="MatrixSidebar-Connections-row">
          <div>
            <MatrixSidebarConnections
              nodes={matrix.nodes}
              showAllConnections={showAllConnections}
            />
          </div>
        </div>
      </div>
      {/* TODO Need this to be if you are in editable matrix with results or an experiment */}
      {!!nodeResults || matrix?.parentId ? (
        <div className="MatrixSidebar-Connections-bottom">
          <div className="MatrixSidebar-Connections-header-button">
            <ButtonNew
              label="Compare"
              buttonClasses={classNames(
                'secondary-button-dark-small tour-compare-results-button',
                { disabled: chartView }
              )}
              onClick={() => {
                setConnectionsTabOpen(false);
                setChartView('graphs');
              }}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default ConnectionsSidebar;
